'use client'

import { Clipboard } from 'lucide-react'
import { message } from '@/components/Toast'

// 客服 QQ 与微信号相同；集中定义避免散落的硬编码号码。
export const SUPPORT_CONTACT_NUMBER = '824444270'
export const SUPPORT_QQ = SUPPORT_CONTACT_NUMBER
export const SUPPORT_WECHAT_ID = SUPPORT_CONTACT_NUMBER

export async function copySupportContact(value: string, label: string): Promise<void> {
  try {
    await navigator.clipboard.writeText(value)
    message.success(`已复制${label}：${value}`)
  } catch {
    message.error('复制失败，请手动复制')
  }
}

/** 号码 + 复制按钮的内联片段，登录页与客服页共用。 */
export function CopyableSupportNumber({ value, label }: { value: string; label: string }) {
  return (
    <span className="inline-flex items-center gap-1">
      <span className="font-medium text-ink">{value}</span>
      <button
        type="button"
        className="inline-flex items-center rounded p-1 text-muted transition-colors hover:text-accent"
        aria-label={`复制${label}`}
        title={`复制${label}`}
        onClick={() => void copySupportContact(value, label)}
      >
        <Clipboard size={14} />
      </button>
    </span>
  )
}
